import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit, Pipe, PipeTransform } from '@angular/core';
import { AuthService } from '../../../../core/services/auth.service';
import { UsersService } from '../../../../core/services/users.service';
import { LoaderService } from '../../../../core/shared/services/loader.service';
import { BaseComponent } from '../../../../core/shared/base.component';
import { TimeFormatPipe } from '../../../../core/shared/pipes/time-format.pipe';
import { DateFormatPipe } from '../../../../core/shared/pipes/date-format.pipe';



// @Pipe({
//   name: 'timeFormat',
//   standalone: true
// })
// export class TimeFormatPipe implements PipeTransform {
//   transform(time: string): string {
//     if (!time) return '';

//     const [hours, minutes] = time.split(':');
//     const hour24 = parseInt(hours, 10);
//     const hour12 = hour24 === 0 ? 12 : hour24 > 12 ? hour24 - 12 : hour24;
//     const period = hour24 < 12 ? 'AM' : 'PM';

//     return `${hour12}:${minutes} ${period}`;
//   }
// }

// @Pipe({
//   name: 'dateFormat',
//   standalone: true
// })
// export class DateFormatPipe implements PipeTransform {
//   transform(dateString: string): string {
//     if (!dateString) return '';

//     // const [day, month, year] = dateString.split('/');
//     const [year, month, day] = dateString.split('-'); // Cambiado para formato YYYY-MM-DD
//     const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));

//     const dayNames = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
//     const dayName = dayNames[date.getDay()];

//     return `${dayName} ${day.padStart(2, '0')}`;
//   }
// }

interface DateItem {
  day: string;
  date: number;
  selected: boolean;
}

interface SummaryItem {
  day: string;
  times: string[];
}

@Component({
  selector: 'app-mentor-availability',
  standalone: true,
  imports: [CommonModule, TimeFormatPipe, DateFormatPipe],
  templateUrl: './mentor-availability.component.html',
  styleUrl: './mentor-availability.component.scss'
})
export class MentorAvailabilityComponent extends BaseComponent {
  private loaderService = inject(LoaderService);
  private authService = inject(AuthService);
  private usersService = inject(UsersService);
  public user: any = {};
  // @Input() user: any = {}; // <--- declarar el Objeto de tipo dinámico (anónimo)


  currentWeek = '01 - 07 Abr del 2024';
  selectedDate = 'Martes 02';
  selectedPeriod = 'Mañana';

  // Mantener referencia a la semana actual mostrada
  private currentWeekStartDate: Date = new Date();

  constructor() {
    super();
    this.user = this.authService.getUser();
    console.log('USUARIO INPUT:', this.user);
    console.log('timeSlots', this.timeSlots);
    this.loadSummaryData(this.user._id);

    this.initializeCurrentWeek();
    this.getSummaryForWeekDate();
  }

  dateItems: DateItem[] = [
    { day: 'LUN', date: 1, selected: false },
    { day: 'MAR', date: 2, selected: false },
    { day: 'MIE', date: 3, selected: true },
    { day: 'JUE', date: 4, selected: false },
    { day: 'VIE', date: 5, selected: false },
    { day: 'SAB', date: 6, selected: false }
  ];

  periods = ['Mañana', 'Tarde', 'Noche'];

  timeSlots: { [key: string]: string[] } = {
    'Mañana': ['08:00', '09:00', '10:00', '11:00', '12:00'],
    'Tarde': ['13:00', '14:00', '15:00', '16:00', '17:00'],
    'Noche': ['18:00', '19:00', '20:00', '21:00', '22:00']
  };
  // selectedTimes = new Set<string>(['09:00']);
  selectedTimes = new Set<string>([]);
  // summaryData: SummaryItem[] = [
  //   { day: '2025-06-20', times: ['10:30', '15:30', '18:00'] },
  //   { day: '2025-06-21', times: ['15:30', '18:00'] },
  //   { day: '2025-06-23', times: ['18:00'] }
  // ];
  summaryData: SummaryItem[] = [];

  weekSummary: SummaryItem[] = [];
  selectedSummary: SummaryItem[] = [];

  selectDate(item: DateItem) {
    this.dateItems.forEach(d => d.selected = false);
    item.selected = true;
    this.selectedDate = `${this.getDayName(item.day)} ${item.date.toString().padStart(2, '0')}`;
    this.selectedTimes.clear();
  }

  selectPeriod(period: string) {
    this.selectedPeriod = period;
    this.selectedTimes.clear();
  }

  toggleTimeSlot(time: string) {
    if (this.selectedTimes.has(time)) {
      this.selectedTimes.delete(time);
    } else {
      this.selectedTimes.add(time);
    }

    // Mostrar la fecha seleccionada
    const currentDate = this.getCurrentDateFromSelection();
    console.log('Fecha seleccionada:', currentDate);
    // Mostrar los tiempos seleccionados
    const selectedTimesArray = Array.from(this.selectedTimes);
    console.log('Tiempos seleccionados:', selectedTimesArray);


    this.selectedSummary = this.summaryData.filter(item => item.day === currentDate);
    this.selectedSummary.push({
      day: currentDate,
      times: selectedTimesArray
    });

    // Actualizar el resumen de disponibilidad busando la fecha actual

    // this.summaryData.map(item => {
    //   // Verificar si la fecha actual ya existe en el resumen
    //   if (item.day === currentDate) {
    //     item.times = selectedTimesArray; // Actualizar los tiempos para la fecha actual
    //   }

    //   // Si la fecha no existe, agregarla
    //   if (!this.summaryData.some(i => i.day === currentDate)) {
    //     this.summaryData.push({
    //       day: currentDate,
    //       times: selectedTimesArray
    //     });
    //   }
    //   return item;
    // });

    // this.summaryData = this.summaryData.filter(item => item.day !== currentDate); // Eliminar entradas antiguas para la fecha actual
    // this.summaryData.push({
    //   day: currentDate,
    //   times: selectedTimesArray
    // });
    console.log('selectedSummary:', this.selectedSummary);
  }

  isTimeSelected(time: string): boolean {
    return this.selectedTimes.has(time);
  }

  getCurrentTimeSlots(): string[] {
    return this.timeSlots[this.selectedPeriod] || [];
  }

  // Para deshabilitar el boton time si existe en el array summaryData  
  isTimeDisabled(time: string): boolean {
    const currentDate = this.getCurrentDateFromSelection();
    const existingSummary = this.summaryData.find(item => item.day === currentDate);
    // console.log('existingSummary', existingSummary)
    let res = existingSummary ? existingSummary.times.includes(time) : false;
    // console.log('res', res, time);
    return res;
  }

  getDayName(abbreviation: string): string {
    const days: { [key: string]: string } = {
      'LUN': 'Lunes',
      'MAR': 'Martes',
      'MIE': 'Miércoles',
      'JUE': 'Jueves',
      'VIE': 'Viernes',
      'SAB': 'Sábado'
    };
    return days[abbreviation] || abbreviation;
  }

  navigateWeek(direction: number) {
    // Navegar desde la semana actualmente mostrada
    const newWeekStart = new Date(this.currentWeekStartDate);
    newWeekStart.setDate(this.currentWeekStartDate.getDate() + (direction * 7));

    // Actualizar la fecha de referencia
    this.currentWeekStartDate = newWeekStart;

    // Actualizar los días y el rango de la semana
    this.updateWeekFromDate(newWeekStart);

    this.getSummaryForWeekDate();
  }

  private updateWeekFromDate(startDate: Date) {
    const weekDays: DateItem[] = [];
    const dayAbbreviations = ['LUN', 'MAR', 'MIE', 'JUE', 'VIE', 'SAB'];

    // Generar los 6 días de la semana desde la fecha de inicio
    for (let i = 0; i < 6; i++) {
      const currentDate = new Date(startDate);
      currentDate.setDate(startDate.getDate() + i);

      weekDays.push({
        day: dayAbbreviations[i],
        date: currentDate.getDate(),
        selected: false
      });
    }

    this.dateItems = weekDays;

    // Actualizar el rango de la semana
    const saturday = new Date(startDate);
    saturday.setDate(startDate.getDate() + 5);

    const monthNames = [
      'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
      'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
    ];

    const startDay = startDate.getDate().toString().padStart(2, '0');
    const endDay = saturday.getDate().toString().padStart(2, '0');
    const month = monthNames[startDate.getMonth()];
    const year = startDate.getFullYear();

    this.currentWeek = `${startDay} - ${endDay} ${month} del ${year}`;

    // Seleccionar el primer día por defecto
    if (this.dateItems.length > 0) {
      this.dateItems[0].selected = true;
      this.selectedDate = `${this.getDayName(this.dateItems[0].day)} ${this.dateItems[0].date.toString().padStart(2, '0')}`;
    }
  }

  saveAvailability() {

    // alert('Disponibilidad guardada exitosamente');
    // Validar que al menos un horario esté seleccionado
    if (this.selectedTimes.size === 0) {
      this.info('Debe seleccionar al menos un horario antes de guardar.', '', 'Aceptar', true);
      // alert('Por favor, seleccione al menos un horario antes de guardar.');
      return;
    }
    // agregar a summaryData los selectedSummary
    this.selectedSummary.forEach(item => {
      // Verificar si el día ya existe en summaryData
      const existingItem = this.summaryData.find(i => i.day === item.day);
      if (existingItem) {
        // Actualizar los tiempos existentes
        existingItem.times = Array.from(new Set([...existingItem.times, ...item.times]));
        // existingItem.times = Array.from(item.times);
      } else {
        // Agregar un nuevo resumen
        this.summaryData.push(item);
      }
    }
    );
    // this.selectedSummary

    // Asegurar que se actualizan el campo coachAvailability
    const userData = {
      _id: this.user._id || this.user.id,
      coachAvailability: this.summaryData
    };

    this.loaderService.show();
    this.usersService.updateCoachAvailability(userData).subscribe({
      next: (response) => {
        if (response && response.data) {
          const res: any = response.data;
          console.log('SAVE:', response.data);
          this.loadSummaryData(res._id);
          // this.getSummaryForWeekDate()
          this.success('Disponibilidad guardada correctamente');
          this.loaderService.hide();
        }

      },
      error: (err) => {
        console.error('Error al guardar actividad del coach:', err);
        this.loaderService.hide();
      }
    });

    console.log('Datos del usuario a actualizar:', userData);

    console.log('Guardando disponibilidad:', this.summaryData);
  }

  getCurrentWeekDays(): DateItem[] {
    const today = new Date();
    const currentDay = today.getDay(); // 0 = domingo, 1 = lunes, etc.

    // Calcular el lunes de la semana actual
    const mondayOffset = currentDay === 0 ? -6 : 1 - currentDay;
    const monday = new Date(today);
    monday.setDate(today.getDate() + mondayOffset);
    console.log('Lunes de la semana actual:', monday);

    const weekDays: DateItem[] = [];
    const dayAbbreviations = ['LUN', 'MAR', 'MIE', 'JUE', 'VIE', 'SAB'];

    // Generar los 6 días de la semana (lunes a sábado)
    for (let i = 0; i < 6; i++) {
      const currentDate = new Date(monday);
      currentDate.setDate(monday.getDate() + i);

      weekDays.push({
        day: dayAbbreviations[i],
        date: currentDate.getDate(),
        selected: this.isSameDate(currentDate, today)
      });
    }

    return weekDays;
  }

  private isSameDate(date1: Date, date2: Date): boolean {
    return date1.getDate() === date2.getDate() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getFullYear() === date2.getFullYear();
  }

  getCurrentWeekRange(): string {
    const today = new Date();
    const currentDay = today.getDay();

    // Calcular el lunes de la semana actual
    const mondayOffset = currentDay === 0 ? -6 : 1 - currentDay;
    const monday = new Date(today);
    monday.setDate(today.getDate() + mondayOffset);

    // Calcular el sábado de la semana actual
    const saturday = new Date(monday);
    saturday.setDate(monday.getDate() + 5);

    const monthNames = [
      'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
      'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
    ];

    const startDay = monday.getDate().toString().padStart(2, '0');
    const endDay = saturday.getDate().toString().padStart(2, '0');
    const month = monthNames[monday.getMonth()];
    const year = monday.getFullYear();

    return `${startDay} - ${endDay} ${month} del ${year}`;
  }
  initializeCurrentWeek() {
    // Establecer la fecha de referencia al lunes de la semana actual
    const today = new Date();
    const currentDay = today.getDay();
    const mondayOffset = currentDay === 0 ? -6 : 1 - currentDay;
    const monday = new Date(today);
    monday.setDate(today.getDate() + mondayOffset);

    this.currentWeekStartDate = monday;

    this.dateItems = this.getCurrentWeekDays();
    this.currentWeek = this.getCurrentWeekRange();

    // Actualizar la fecha seleccionada si hoy está en los días mostrados
    const selectedItem = this.dateItems.find(item => item.selected);
    if (selectedItem) {
      this.selectedDate = `${this.getDayName(selectedItem.day)} ${selectedItem.date.toString().padStart(2, '0')}`;
    }
  }

  navigateDay(direction: number) {
    const currentSelectedIndex = this.dateItems.findIndex(item => item.selected);
    if (currentSelectedIndex === -1) return;

    const newIndex = currentSelectedIndex + direction;

    // Verificar que el nuevo índice esté dentro de los límites de la semana actual
    if (newIndex >= 0 && newIndex < this.dateItems.length) {
      // Navegar dentro de la misma semana
      this.dateItems.forEach(d => d.selected = false);
      this.dateItems[newIndex].selected = true;
      const selectedItem = this.dateItems[newIndex];
      this.selectedDate = `${this.getDayName(selectedItem.day)} ${selectedItem.date.toString().padStart(2, '0')}`;
      this.selectedTimes.clear();
    }
    // Si el índice está fuera de los límites, no hacer nada (no navegar)
  }

  canNavigateToPreviousDay(): boolean {
    const currentSelectedIndex = this.dateItems.findIndex(item => item.selected);
    return currentSelectedIndex > 0;
  }

  canNavigateToNextDay(): boolean {
    const currentSelectedIndex = this.dateItems.findIndex(item => item.selected);
    return currentSelectedIndex < this.dateItems.length - 1;
  }

  private formatDateToString(date: Date): string {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    // return `${day}/${month}/${year}`;
    return `${year}-${month}-${day}`;
  }

  private getCurrentDateFromSelection(): string {
    // Obtener la fecha actual basada en la selección
    const selectedItem = this.dateItems.find(item => item.selected);
    if (!selectedItem) return '';

    // Crear una fecha basada en la semana actual y el día seleccionado
    const selectedIndex = this.dateItems.findIndex(item => item.selected);
    const selectedDate = new Date(this.currentWeekStartDate);
    selectedDate.setDate(this.currentWeekStartDate.getDate() + selectedIndex);

    return this.formatDateToString(selectedDate);
  }

  /**
   * Obtiene el resumen de disponibilidad para la semana actual.
   * Filtra los datos de resumen para incluir solo aquellos que coinciden con los días de la semana actual.
   */
  getSummaryForWeekDate(): any {
    // Obtener todas las fechas de la semana actual
    const currentWeekDates = this.getCurrentWeekDates();
    console.log('Fechas de la semana actual:', currentWeekDates);

    // Filtrar summaryData por las fechas de la semana actual
    this.weekSummary = this.summaryData.filter(item =>
      currentWeekDates.includes(item.day)
    );

    console.log('Resumen filtrado para la semana:', this.weekSummary);

    // ordenar times dentro de cada item de weekSummary
    this.weekSummary.map(item => {
      item.times.sort();
    });
    // ordenar weekSummary por día
    this.weekSummary.sort((a, b) => new Date(a.day).getTime() - new Date(b.day).getTime());

    return this.weekSummary;
  }

  private getCurrentWeekDates(): string[] {
    const weekDates: string[] = [];

    // Generar las fechas para todos los días de la semana actual (lunes a sábado)
    for (let i = 0; i < 6; i++) {
      const currentDate = new Date(this.currentWeekStartDate);
      currentDate.setDate(this.currentWeekStartDate.getDate() + i);
      weekDates.push(this.formatDateToString(currentDate));
    }

    return weekDates;
  }

  loadSummaryData(userId: string) {
    this.usersService.findById(userId).subscribe({
      next: (response) => {
        if (response && response.data) {
          const res: any = response.data;
          this.summaryData = res.coachAvailability;
          // console.log('res.coachAvailability:', res.coachAvailability);
          // console.log('AAAAAAA:', this.summaryData);
          this.getSummaryForWeekDate()
        }

      }
    });
    // Aquí deberías implementar la lógica para obtener el usuario por ID
    // Por ejemplo, podrías hacer una llamada a un servicio que obtenga los datos del usuario
    // return this.usersService.findById(userId);
    return {}; // Retornar un objeto vacío por ahora
  }

}
